import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_TITLE = "Yuva | UX Director & AI-Native Product Designer";
const SITE_URL = "https://yuvadesign.in";
const DEFAULT_DESC =
  "Yuva Kumar — UX Director & AI-Native Product Designer with 20+ years scaling design across APAC. UX strategy, design systems governance, Agentic AI in design, and enterprise product leadership.";
const DEFAULT_IMG =
  "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?q=80&w=1200&auto=format&fit=crop";

/**
 * SEO / GEO (Generative Engine) / AEO (Answer Engine) metadata.
 * Title stays constant across all pages (per brand spec); description,
 * canonical, social cards and JSON-LD structured data vary per page.
 */
export const Seo = ({
  description = DEFAULT_DESC,
  path = "/",
  image = DEFAULT_IMG,
  keywords,
  jsonLd,
  type = "website",
}) => {
  const url = `${SITE_URL}${path}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{SITE_TITLE}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Yuva Kumar — UX Director" />
      <meta property="og:title" content={SITE_TITLE} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={SITE_TITLE} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
};

export { SITE_URL, SITE_TITLE };
export default Seo;
